module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    on: {
      "click": function($event) {
        _vm.$emit('click')
      }
    }
  }, [(_vm.order.randomDiscountAmount && _vm.order.randomDiscountAmount > 0) ? _c('div', {
    staticClass: "randomDiscountAmoutContainer"
  }, [_vm._v("\n    " + _vm._s(("本单减免" + (_vm.formatPrice(_vm.order.randomDiscountAmount)))) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.formatDateByDate(_vm.order.consumeDate)) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "period-name"
  }, [_vm._v(" " + _vm._s(_vm.order.periodName + ' - ' + _vm.order.hallName) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.resource.orderStatus[_vm.order.baseOrderViewStatus]))])]), _vm._v(" "), _c('div', {
    staticClass: "full-divide"
  }), _vm._v(" "), _c('div', {
    staticClass: "dishes"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.order.dishes), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "dish-item"
    }, [_c('div', {
      staticClass: "dish-name"
    }, [_vm._v(" " + _vm._s(item.dishName))]), _vm._v(" "), _c('div', {
      staticClass: "dish-count"
    }, [_vm._v(_vm._s(item.count) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "dish-price"
    }, [_vm._v(" " + _vm._s(_vm.formatPrice(item.subtotalPrice)))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "full-divide"
  }), _vm._v(" "), (_vm.buttons && _vm.buttons.length > 0) ? _c('div', {
    staticClass: "footer"
  }, _vm._l((_vm.buttons), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "button",
      class: item.secondy ? 'secondy' : '',
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.handleClick(item.code)
        }
      }
    }, [_vm._v("\n      " + _vm._s(item.text) + "\n    ")])
  })) : _c('div', {
    staticClass: "footer-placeholder"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dish-item"
  }, [_c('div', {
    staticClass: "dish-name hint-color"
  }, [_vm._v("菜品")]), _vm._v(" "), _c('div', {
    staticClass: "dish-count hint-color"
  }, [_vm._v("数量 ")]), _vm._v(" "), _c('div', {
    staticClass: "dish-price hint-color"
  }, [_vm._v(" 价格")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3e1e7875!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/order.vue
// module id = 841
// module chunks = 34